/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 (function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        initSlideShow();
        categoryListHover();

        $(window).on('resize', function(){
          if ($(window).width() < 767 ) {
            $('#navbar, .main-nav .dropdown, #menu-main-menu, #menu-how-menu, #menu-who-menu').addClass('collapse');
            $('.dropdown').removeAttr('style');
          } else {
            $('#navbar, .main-nav .dropdown, #menu-main-menu, #menu-how-menu, #menu-who-menu').removeClass('collapse');
          }
        }).resize();

        $(window).on('resize', function() {
          if ($(window).width() < 767 ) {
            // do nothing
            $('#menu-main-menu > li.menu-item-has-children, .sub-nav > li.has-children').removeClass('hover');
          } else {

          }
        }).resize();

        // Show dropdown on click
        // Add off() to prevent firing multiple
        $('#menu-main-menu > li.menu-item-has-children > a, .sub-nav > li.has-children > a').on('click',function(e) {

          if ($(window).width() < 767 ) {
            // do nothing
          } else {


              if($(this).parent().hasClass('hover')) {
                // $(this).parent().removeClass('hover');
                $('#menu-main-menu').find('.hover').removeClass('hover');
                console.log('Remove Class');
              } else {
                $('#menu-main-menu > li.menu-item-has-children, .sub-nav > li.has-children').removeClass('hover');
                $(this).parent().addClass('hover');
                console.log('Add Class');
                // $('.hover').not($this.parent()).removeClass('hover');
              }
              e.stopPropagation();
              e.preventDefault();

          }
          // var $this = $(this);


        });

        // Close dropdown button
        $('.close-dropdown').on('click',function(e){
          $('.hover').removeClass('hover');
          e.stopPropagation();
          e.preventDefault();
        });

        // Close menu on page click
        $('.content').on('click',function(e){
          $('.hover').removeClass('hover');
                        // console.log('Content Clicked');
        });
	      $('.full-size-wrap').on('click',function(e){
          $('.hover').removeClass('hover');
                                  // console.log('Fullsize Clicked');

        });

        // $('.js-show-all').on('click',function(e){
        //   //$('#menu-main-menu li').addClass('hover');
        //   e.preventDefault();
        // });

        /*----- Events --------*/
        $('.js-load-products').on('click',function(e){
          $term_slug = $(this).attr('data-slug');
          loadProductsByTerm($term_slug);
          $('.side-nav .panel>a').removeClass('active');
          e.preventDefault();
        });

        $('.js-load-manufacturer').on('click',function(e){
          $term_slug = $(this).attr('data-slug');
          loadProductsByManufacturer($term_slug);
          $('.side-nav .panel>a').removeClass('active');
          e.preventDefault();
        });

        $('.js-load-terms').on('click',function(e){
          loadAllTerms();
          if($(this).next('.panel-collapse').length ===0){
            $(this).toggleClass('active');
            $('#accordion .panel-collapse.in').collapse('hide');
          }
          e.preventDefault();
        });

        if($(window) > 1024){
          $('.cat-block figcaption').on('click',function(e){
            $link = $(this).find('a').attr('href');
            window.location = $link;
            e.preventDefault();
          });
        }

		// Mobile menu add js-show-all
		$(window).resize(function() {
		  if ($(window).width() < 768) {
			 $( ".menu-item > a" ).addClass( "js-show-all" );
		  }
		 else {
			 $( ".menu-item > a" ).removeClass( "js-show-all" );
		 }
		}).resize();

		if ( window.location.pathname == '/' ){
		// Nothing
		} else {
			$(window).resize(function() {
			  if ($(window).width() < 768) {
				 $('#menu-main-menu > .menu-item > a').attr('href','/#intro-home');
			  }
			 else {
				//  $('#menu-main-menu .dropdown__products .menu-item > a').attr('href','#');
         $('#menu-main-menu > .menu-item > a').attr('href','#');
			 }
			}).resize();
		}

        /*-------- Product Carousel ----------*/
        $owl = $('.owl-carousel');
        $owl.owlCarousel({
           items:1,
           merge:true,
           loop:true,
           margin:10,
           video:true,
           //lazyLoad:true,
           center:true,
           //responsive: true,
           autoHeight:false,
           navigation:true,
           responsiveRefreshRate : 200,
           responsiveBaseWidth: window,
           navSpeed : true,
           smartSpeed:1300,
           onTranslate: function() {
                   $('.owl-item').find('video').each(function() {
                       this.pause();
                   });
               },
           responsive:{
            375:{
              items: 1
            },
             480:{
               items:2
             },
             600:{
               items:4
             }
           }
             });

        // Video playing on slide change..
        // $owl.on('changed.owl.carousel', function(event) {
        //   $currClass = $('.product-slider div:eq(' + (event.item.index -1) + ')').hasClass('item-video');
        //   $('.owl-carousel div:eq(' + (event.item.index) + ')').find('.owl-video-play-icon').trigger('click');
        //   $current = $('.owl-item.active.center');
        //   var currentItem = event.item.index;
        //   $(".owl-item:eq(" + currentItem + ")").find('.owl-video-play-icon').trigger('click');
        // });

        $owl.on('resize.owl.carousel', function(event) {
          $currentHeight = $owl.height();
          $('.item-video').css('height',$currentHeight);
          $('.item-video-playing').css('height',$currentHeight);
        });


        $currentHeight = $owl.height();
        $('.item-video').css('height',$currentHeight);


        $(".controls__next a").click(function(e){
          $owl.trigger('next.owl.carousel');
          e.preventDefault();
        });

        $(".controls__prev a").click(function(e){
          $owl.trigger('prev.owl.carousel');
          e.preventDefault();
        });


        $('.js-more-items').on('click',function(e){
          $postType = $(this).attr('data-type');
          loadMoreItems($postType);
          e.preventDefault();
        });

        if($('.panel-products-loader__items--tax').length){

        }

        if($('.Downloads').length){
          $('.que-downloadlink').show();
        }

        $('.showmore').on('click',function(e){
          $(this).parent().find('.model-listing--hidden').fadeIn();
          e.preventDefault();
          if ( $winW() > 724 ){
            $(this).parent().css('paddingBottom','150px');
          }
          $(this).fadeOut();
        });

        $('.js_submenu').on('click',function(e){
          $(this).toggleClass('active_menu');
          $selected = '';
          $amount = $('.active_menu').length;
          if($amount === 0){
            $term_slug =  $(this).closest('.panel-default').find('.js-load-products').attr('data-slug');
            loadProductsByTerm($term_slug);
          }else{
            $.each($('.js_submenu.active_menu'),function(index){
                $term_slug = $(this).attr('data-slug');
                if(index !== $amount - 1){
                  $selected += $term_slug + ', ';
                }else{
                  $selected += $term_slug;
                }
            });
            loadProductsByTerm($selected);
          }
          e.preventDefault();
        });
        
        $('.js_submenu-manufacturer').on('click',function(e){
          $(this).toggleClass('active_menu');
          $selected = '';
          $amount = $('.active_menu').length;
          if($amount === 0){
            $term_slug =  $(this).closest('.panel-default').find('.js-load-manufacturer').attr('data-slug');
            loadProductsByManufacturer($term_slug);
          }else{
            $.each($('.js_submenu-manufacturer.active_menu'),function(index){
                $term_slug = $(this).attr('data-slug');
                if(index !== $amount - 1){
                  $selected += $term_slug + ', ';
                }else{
                  $selected += $term_slug;
                }
            });
            loadProductsByManufacturer($selected);
          }
          e.preventDefault();
        });


        $('.js_load_term_children').on('click',function(e){
            $term_id = $(this).attr('data-term-id');
            loadTermChildren($term_id);
            e.preventDefault();
        });

        $('.js-hm-scroll-products').on('click',function(e){
          //var tabOffset = ($('.panel-products-loader__nav').offset().top - 50) ;
          var tabOffset = ($('#intro-home').offset().top + 50) ;
          $("html:not(:animated),body:not(:animated)").animate({ scrollTop:tabOffset}, 1500);
          e.preventDefault();
        });

        // Remove No-js Class
        $("html").removeClass('no-js').addClass('js');


        /* Tab Content box
        ----------------------*/
        var tabBlockElement = $('.tab-data');
        $(tabBlockElement).each(function(index, element) {
          var $this = $(this),
          tabTrigger = $this.find(".side-nav .panel"),
          tabContent = $this.find(".tabcontent");
          var textval = [];
          tabTrigger.each(function() {
            textval.push( $(this).text() );
          });

          if(!screencheck(1023)){
            $this.find(tabTrigger).first().addClass("active");
            $this.find(tabContent).first().show();
          }



          $(tabTrigger).on('click',function () {
            $(tabTrigger).removeClass("active");
            $(this).addClass("active");
            $(tabContent).hide().removeClass('visible');
            var activeTab = $(this).find("a").attr("data-rel");
            $this.find('#' + activeTab).fadeIn('normal').addClass('visible');

            return false;
          });

          var responsivetabActive =  function(){
            if (screencheck(1023)){
              if( !$('.tabMobiletrigger').length ){
                $(tabContent).each(function(index, element) {
                  $(this).before("<h2 class='tabMobiletrigger'>"+textval[index]+"</h2>");
                  //$this.find('.tabMobiletrigger:first').addClass("rotate");
                });
                $('.tabMobiletrigger').click('click', function(){
                  var tabAcoordianData = $(this).next('.tabcontent');
                  if($(tabAcoordianData).is(':visible') ){
                    $(this).removeClass('rotate');
                    $(tabAcoordianData).slideUp('normal');
                    //return false;
                  } else {
                    $this.find('.tabMobiletrigger').removeClass('rotate');
                    $(tabContent).slideUp('normal');
                    $(this).addClass('rotate');
                    $(tabAcoordianData).not(':animated').slideToggle('normal');
                  }
                  return false;
                });
              }

            }
            if ( $winW() > 1023 ){
              $('.tabMobiletrigger').remove();
              $this.find(tabTrigger).removeClass("active").first().addClass('active');
              //$this.find(tabContent).hide().first().show();
            }
          };
          $(window).on('resize', function(){
            if(!$this.hasClass('only-tab')){
              responsivetabActive();
            }
          }).resize();
        });

        $('.que-downloadlink').click( function(){
          var tabOffset = $('.tab-data .side-nav').offset().top;
          $("html:not(:animated),body:not(:animated)").animate({ scrollTop:tabOffset}, 'noraml');
          $('.tab-data .side-nav .Downloads a').trigger('click');
          return false;
        });

        //Smooth back to top
        $('.backtotop').click(function(){
          $("html:not(:animated),body:not(:animated)").animate({ scrollTop:0}, 1800);
          return false;
        });

        $(window).scroll(function(){
          if($(this).scrollTop() > 600){
            $('.backtotop').fadeIn('slow');
          } else {
            $('.backtotop').fadeOut('slow');
          }

          return false;
        });


        // if not home - update show all functionality
        if(window.location.pathname == '/' ) {
          // do nothing
        } else {
          $('.js-doors a').on('click',function(e){
            if($(this).hasClass('js-show-all')) {
              window.location.href = '/?show=doors#intro-home';
              $('#menu-main-menu').find('.hover').removeClass('hover');
              e.preventDefault();
              console.log('has class');
            } else {
              console.log('NO class');
            }
          });

          $('.js-glazing a').on('click',function(e){
            if($(this).hasClass('js-show-all')) {
              window.location.href = '/?show=glazing#intro-home';
              e.preventDefault();
            }
          });

          $('.js-flooring a').on('click',function(e){
            if($(this).hasClass('js-show-all')) {
              window.location.href = '/?show=flooring#intro-home';
              e.preventDefault();
            }
          });

          $('.js-lighting a').on('click',function(e){
            if($(this).hasClass('js-show-all')) {
              window.location.href = '/?show=lighting#intro-home';
              e.preventDefault();
            }
          });

          $('.js-walls a').on('click',function(e){
            if($(this).hasClass('js-show-all')) {
              window.location.href = '/?show=walls#intro-home';
              e.preventDefault();
            }
          });

          $('.js-wine a').on('click',function(e){
            if($(this).hasClass('js-show-all')) {
              window.location.href = '/?show=wine#intro-home';
              e.preventDefault();
            }
          });

             $('.js-office a').on('click',function(e){
             if($(this).hasClass('js-show-all')) {
               window.location.href = '/?show=office-and-partitions#intro-home';
             e.preventDefault();
             }
          });
        }

        //Pinterest

				window.PinIt = window.PinIt || { loaded:false };
				if (window.PinIt.loaded) return;
				window.PinIt.loaded = true;
				function async_load(){
				    var s = document.createElement("script");
				    s.type = "text/javascript";
				    s.async = true;
				    s.src = "https://assets.pinterest.com/js/pinit.js";
				    var x = document.getElementsByTagName("script")[0];
				    x.parentNode.insertBefore(s, x);
				}
				if (window.attachEvent)
				    window.attachEvent("onload", async_load);
				else
				    window.addEventListener("load", async_load, false);

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

        $(window).resize(function() {
          homeSlideHeight();
        }).resize();

        window.addEventListener("orientationchange", function() {
          homeSlideHeight();
        }, false);

        $('.js-doors a').on('click',function(){
            if($(this).hasClass('js-show-all')) {
              $('*[data-slug="doors"]').trigger('click');
              $('.js-hm-scroll-products').trigger('click');
              $('#menu-main-menu').find('.hover').removeClass('hover');
              console.log('doors clicked');
            } else {
                          console.log('doors clicked not if');

            }
          });
          $('.js-glazing a').on('click',function(){
            if($(this).hasClass('js-show-all')) {
              $('*[data-slug="glazing"]').trigger('click');
              $('.js-hm-scroll-products').trigger('click');
              $('#menu-main-menu').find('.hover').removeClass('hover');
            }
          });

          $('.js-flooring a').on('click',function(){
            if($(this).hasClass('js-show-all')) {
              $('*[data-slug="flooring"]').trigger('click');
              $('.js-hm-scroll-products').trigger('click');
              $('#menu-main-menu').find('.hover').removeClass('hover');
            }
          });

          $('.js-lighting a').on('click',function(){
            if($(this).hasClass('js-show-all')) {
              $('.js-load-terms.active').removeClass('active');
              $('#title4').trigger('click');
              $('.js-hm-scroll-products').trigger('click');
              $('#menu-main-menu').find('.hover').removeClass('hover');
            }
          });

          $('.js-walls a').on('click',function(){
            if($(this).hasClass('js-show-all')) {
              $('*[data-slug="walls"]').trigger('click');
              $('.js-hm-scroll-products').trigger('click');
              $('#menu-main-menu').find('.hover').removeClass('hover');
            }
          });

          $('.js-wine a').on('click',function(){
            if($(this).hasClass('js-show-all')) {
              $('*[data-slug="wine"]').trigger('click');
              $('.js-hm-scroll-products').trigger('click');
              $('#menu-main-menu').find('.hover').removeClass('hover');
            }
          });

            $('.js-office a').on('click',function(){
            if($(this).hasClass('js-show-all')) {
              $('*[data-slug="office-and-partitions"]').trigger('click');
              $('.js-hm-scroll-products').trigger('click');
              $('#menu-main-menu').find('.hover').removeClass('hover');
            }
          });

        // $('.js-doors .js-show-all').on('click',function(){
        //   $('*[data-slug="doors"]').trigger('click');
        //   $('.js-hm-scroll-products').trigger('click');
        //   console.log('CLICKED');
        //   $('#menu-main-menu').find('.hover').removeClass('hover');
        // });

        // $('.js-glazing .js-show-all').on('click',function(){
        //   $('*[data-slug="glazing"]').trigger('click');
        //   $('.js-hm-scroll-products').trigger('click');
        //   $('#menu-main-menu').find('.hover').removeClass('hover');
        // });

        // $('.js-flooring .js-show-all').on('click',function(){
        //   $('*[data-slug="flooring"]').trigger('click');
        //   $('.js-hm-scroll-products').trigger('click');
        //   $('#menu-main-menu').find('.hover').removeClass('hover');
        // });

        // $('.js-lighting .js-show-all').on('click',function(){
        //   $('.js-load-terms.active').removeClass('active');
        //   $('#title4').trigger('click');
        //   $('.js-hm-scroll-products').trigger('click');
        //   $('#menu-main-menu').find('.hover').removeClass('hover');
        // });

        // $('.js-walls .js-show-all').on('click',function(){
        //   $('*[data-slug="walls"]').trigger('click');
        //   $('.js-hm-scroll-products').trigger('click');
        //   $('#menu-main-menu').find('.hover').removeClass('hover');
        // });

        // $('.js-wine .js-show-all').on('click',function(){
        //   $('*[data-slug="wine"]').trigger('click');
        //   $('.js-hm-scroll-products').trigger('click');
        //   $('#menu-main-menu').find('.hover').removeClass('hover');
        // });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'tax_product_category': {
      init: function() {
        if($('.js-slug-parent').length){
          $current_term_slug = $('.js-slug-parent').attr('data-slug');
          loadProductsByTerm($current_term_slug,'product_category');
        }

        $('.js-load-products-lt').on('click',function(e){
          $current_term_slug = $(this).attr('data-slug');
          $perPage = $(this).attr('data-perpage');
          loadLights($current_term_slug,$perPage);
          e.preventDefault();
        });

      }
    },
    'tax_manufacturer': {
      init: function() {
        if($('.js-slug-parent').length){
          $current_term_slug = $('.js-slug-parent').attr('data-slug');
          loadProductsByManufacturer($current_term_slug,'manufacturer');
        }
      }
    },
    'journal': {
      init: function() {

      }
    },
    'single_post': {
      init: function() {

      }
    },
    'case_studies': {
      init: function() {

      }
    },
    'term_lighting': {
      init: function() {
        //$current_term_id = $('.js-slug-parent').attr('data-id');
        //loadAllTerms($current_term_id);
      }
    },
    'single_product': {
      init: function() {

        $('.model-listing.smaller').each(function(index){
          if($(this).find('li').length < 16){
            $(this).parent().addClass('displayed');
          }
        });

        $('.model-listing.bigger').each(function(index){
          if($(this).find('li').length < 7){
            $(this).parent().addClass('displayed');
          }
        });
      }
    }



  };


  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

var xhr; // global object

var $win = $(window),
$doc = $(document),
$winW = function(){ return $(window).width(); },
$winH = function(){ return $(window).height(); },
$screensize = function(element){
  $(element).width($winW()).height($winH());
};

var screencheck = function(mediasize){
  if (typeof window.matchMedia !== "undefined"){
    var screensize = window.matchMedia("(max-width:"+ mediasize+"px)");
    if( screensize.matches ) {
      return true;
    }else {
      return false;
    }
    } else { // for IE9 and lower browser
      if( $winW() <=  mediasize ) {
        return true;
      }else {
        return false;
      }
    }
  };

  function homeSlideHeight(){

    if($(window).width() > 760){
      $carousel =  $('.js-dyn-height .carousel');
      $currPosition = $carousel.offset();
      $textFoldHeight = $('.js-home-rm').height();
      $windowHeight = $(window).height();
      $newHeight = ($windowHeight - $currPosition.top);
      $newHeight = ($newHeight - $textFoldHeight) - 50;
      $('.js-dyn-height .carousel').height($newHeight);
    }

  }

  /*---------- Spinner ----------*/
  var opts = {
    lines: 7, // The number of lines to draw
    length: 8, // The length of each line
    width: 4, // The line thickness
    radius: 42, // The radius of the inner circle
    scale: 1, // Scales overall size of the spinner
    corners: 1, // Corner roundness (0..1)
    color: '#000', // #rgb or #rrggbb or array of colors
    opacity: 0.25, // Opacity of the lines
    rotate: 0, // The rotation offset
    direction: 1, // 1: clockwise, -1: counterclockwise
    speed: 1, // Rounds per second
    trail: 60, // Afterglow percentage
    fps: 20, // Frames per second when using setTimeout() as a fallback for CSS
    zIndex: 2e9, // The z-index (defaults to 2000000000)
    className: 'spinner', // The CSS class to assign to the spinner
    top: '50%', // Top position relative to parent
    left: '50%', // Left position relative to parent
    shadow: false, // Whether to render a shadow
    hwaccel: false, // Whether to use hardware acceleration
    position: 'absolute' // Element positioning
  };

function categoryListHover (){
  // Z-index in reverse order
  /*var zindex = $('.category-listing .cat-block').length;
  $('.category-listing .cat-block figure').css('z-index', function (i) {
    return zindex - i;
  });*/

  $('.category-listing .cat-block figure').hover( function(element){
    //console.log('hovering');
    //$(this).addClass('higherindex');
    var $figureblock = $(this);
    var rightoffeset = ($winW() - ($figureblock.offset().left + $figureblock.width()));

    $position = $(this).position();

    if ( rightoffeset < $figureblock.width() ){
      $(this).addClass('reverse');
    }else if($position.left > 900){
      $(this).addClass('reverse');
    }
    //$(this).find('figcaption').not(':animated').fadeIn(250);
  }, function(){
    var $figure = $(this);
    var rightoffesethov = ($winW() - ($figure.offset().left + $figure.width()));
    if ( rightoffesethov < $figure.width() ){
      $(this).removeClass('reverse');
      //$(this).removeClass('higherindex');
    }


    //$(this).find('figcaption').fadeOut(250);
  });
}

// fade gallery init
function initSlideShow() {
  jQuery('.carousel').fadeGallery({
    slides: '.slide',
    btnPrev: 'a.btn-prev',
    btnNext: 'a.btn-next',
    generatePagination: '.pagination',
    event: 'click',
    useSwipe: true,
    autoRotation: true,
    pauseOnHover: false,
    switchTime: 5000,
    animSpeed: 500
  });
}

function appendLoader($element){
  if($('.spinner').length === 0){
    $loader = '<div class="spinner"></div>';
    $element.append($loader);
    console.log('appendLoader');
  }
}

function removeLoader($element){
  $('.spinner').fadeOut().remove();
}

/* Ajax Functions */

/* Load Products by Term
----------------------*/
function loadProductsByTerm($term_slug,$type){
  $('.panel-products-loader__items__results').fadeOut().empty();
  $('.no-products').remove();
  appendLoader($('.panel-products-loader__items'));

  var data = {
          action: 'load_products_by_term',
          term_slug: $term_slug,
     };

     if(xhr && xhr.readystate != 4){
                xhr.abort();
            }

     xhr = $.ajax( {
    type: "POST",
    url: bb.adminurl,
    data: data,
    success: function ( data ) {
      $html ='';
      if(data!==false){
          $.each(data, function(index, value) {
            $link = value.link;
            $product_name = value.title;
            $manufacturer = value.manufacturer;
            $model        = value.model;
            $img          = value.img;
            $output = ($type === 'product_category')? "<span class='make_model'>" + $manufacturer + " " + $model + "</span>" : "";

            $template = $([
              "<div class='col-sm-6 col-lg-4 col'>",
              "  <div class='product-block product-block--terms'>",
              "     <div class='img-holder'><a href='" + $link + "'><img src='"+ $img + "' height='272' width='356' alt='" + $product_name + "'></a></div>",
              "     <span class='name'><a class='name-link' href=' " + $link + "'>+ " + $product_name + "</a></span>",
              "" + $output + "",
              "  </div>",
              "</div>"
              ].join("\n"));
                    $html += $template[0].outerHTML;

            removeLoader();

        });
          $('.panel-products-loader__items__results').append($html).fadeIn();
      }else{
        removeLoader();
        $('.panel-products-loader__items__results').append('<p class="no-products">sorry, there are no products in this category</p>').fadeIn();
      }
  }
  } );
}

/* Load Products by Manufacturer
 ------------------------------*/
function loadProductsByManufacturer($term_slug,$type){
  $('.panel-products-loader__items__results').fadeOut().empty();
  $('.no-products').remove();
  appendLoader($('.panel-products-loader__items'));

  var data = {
    action: 'load_products_by_manufacturer',
    term_slug: $term_slug,
  };

  if(xhr && xhr.readystate != 4){
    xhr.abort();
  }

  xhr = $.ajax( {
    type: "POST",
    url: bb.adminurl,
    data: data,
    success: function ( data ) {
      $html ='';
      if(data!==false){
        $.each(data, function(index, value) {
          $link = value.link;
          $product_name = value.title;
          $manufacturer = value.manufacturer;
          $model        = value.model;
          $img          = value.img;
          $output = ($type === 'product_category')? "<span class='make_model'>" + $manufacturer + " " + $model + "</span>" : "";

          $template = $([
            "<div class='col-sm-6 col-lg-4 col'>",
            "  <div class='product-block product-block--terms'>",
            "     <div class='img-holder'><a href='" + $link + "'><img src='"+ $img + "' height='272' width='356' alt='" + $product_name + "'></a></div>",
            "     <span class='name'><a class='name-link' href=' " + $link + "'>+ " + $product_name + "</a></span>",
            "" + $output + "",
            "  </div>",
            "</div>"
          ].join("\n"));
          $html += $template[0].outerHTML;

          removeLoader();

        });
        $('.panel-products-loader__items__results').append($html).fadeIn();
      }else{
        removeLoader();
        $('.panel-products-loader__items__results').append('<p class="no-products">sorry, there are no products in this category</p>').fadeIn();
      }
    }
  } );
}


/* Load Lights
----------------------*/
$lights = 2;

function loadLights($term_slug,$perPage){
  var data = {
          action: 'load_lights',
          term_slug: $term_slug,
          per_page: $perPage,
          page: $lights
     };
  var max_num_pages = ''; console.log('loaded lights!');

  $.ajax( {
    type: "POST",
    url: bb.adminurl,
    data: data,
    success: function ( data ,textStatus, request) {
      $html ='';
      $.each(data, function(index, value) {
        $link = value.link;
        $product_name = value.title;
        $manufacturer = (value.manufacturer !== null? value.manufacturer : '');
        $model        = value.model;
        $image        = value.img;
        $alt          = value.alt;

        $template = $([
          " <div class=\"cat-block\">",
          "      <figure>",
          "         <a href='" + $link + "'><img src=\""+ $image + "\" alt=\"" + $alt + "\"></a>",
          "         <figcaption>",
          "           <strong>" +  $product_name + "</strong>",
          "           by " + $manufacturer + "<br>",
          "           <a href='" + $link + "' class=\"view-detail more\">+ VIEW DETAILS</a>",
          "         </figcaption>",
          "       </figure>",
          "   </div>"
          ].join("\n"));
        max_num_pages = value.max_num_pages;

        $html += $template[0].outerHTML;
      });
      $('.js-category-listing').append($html).fadeIn();
      if($lights === max_num_pages){
        $('.js-load-products-lt').fadeOut();
      }else{
        $current_amount = parseInt($('.js-load-products-lt .current_amount').text());
        $new_amount = ($current_amount + data.length);
        $('.js-load-products-lt .current_amount').text($new_amount);
      }
      $lights++;
      categoryListHover();
    },
    //cache: false
  } );
}


/* Load All Terms
----------------------*/
function loadAllTerms(){
  $('.panel-products-loader__items__results').fadeOut().empty();
  $('.no-products').remove();
  appendLoader($('.panel-products-loader__items'));
  var data = {
          action: 'load_all_terms'
     };

  $.ajax( {
    type: "POST",
    url: bb.adminurl,
    data: data,
    success: function ( data ) {
      $html ='';
      if(data!==false){
        $.each(data, function(index, value) {
          $link = value.link;
          $term_name = value.name;
          $term_id = value.term_id;
          $image_url = value.img;
          $template = $([
           "<div class='col-sm-6 col-lg-4 col'>",
           "  <div class='product-block'>",
           "     <div class='img-holder'><a class='js-term-link' data-slug=" + $link + " href='/productcategory/" + $link + "'><img src='" + $image_url + "' height='272' width='356' alt='" + $term_name + "'></a></div>",
           "     <span class='name'><a data-slug=" + $link + " class='name-link js-term-link' href='/productcategory/" + $link + "'>+ " + $term_name + "</a></span>",
           "  </div>",
           "</div>"
           ].join("\n"));
          $html += $template[0].outerHTML;
        });
        removeLoader();
        $('.panel-products-loader__items__results').append($html).fadeIn();

        $('.js-term-link').on('click',function(e){
          //console.log('clicked');
          if($(window).width() > 767){
              if($(this).data('slug') === 'lighting'){
                  //console.log('its lighting');
                  $('.side-nav .js_load_term_children').trigger('click');
              }else{
                $slug = $(this).attr('data-slug');
                $('.js-load-products[data-slug="' + $slug  + '"]').trigger('click');

              }
              e.preventDefault();
          }


        });

    }else{
      removeLoader();
      $('.panel-products-loader__items__results').append('<p class="no-products">sorry, there are no products in this category</p>').fadeIn();
    }
    },
    //cache: false
  });
}


/* Load Term Children
----------------------*/
function loadTermChildren($term_id){
  $('.panel-products-loader__items__results').fadeOut().empty();
  $('.no-products').remove();
  appendLoader($('.panel-products-loader__items'));
  var data = {
          action: 'load_term_children',
          term_id: $term_id
     };

  $.ajax( {
    type: "POST",
    url: bb.adminurl,
    data: data,
    success: function ( data ) {
      $html ='';
      if(data!==false){
        $.each(data, function(index, value) {
          $link = value.link;
          $term_name = value.name;
          $term_id = value.term_id;
          $image_url = value.img;
          $template = $([
           "<div class='col-sm-6 col-lg-4 col'>",
           "  <div class='product-block'>",
           "     <div class='img-holder'><a href='/productcategory/" + $link + "'><img src='" + $image_url + "' height='272' width='356' alt='" + $term_name + "'></a></div>",
           "     <span class='name'><a class='name-link' href='/productcategory/" + $link + "'>+ " + $term_name + "</a></span>",
           "  </div>",
           "</div>"
           ].join("\n"));
          $html += $template[0].outerHTML;
        });
        removeLoader();
        $('.panel-products-loader__items__results').append($html).fadeIn();
    }else{
      removeLoader();
      $('.panel-products-loader__items__results').append('<p class="no-products">sorry, there are no products in this category</p>').fadeIn();
    }
    },
    //cache: false
  });
}
/* Get Term Image Url
----------------------*/
function getTermImageUrl($term_id){
  var image_url = '';
  var data = {
   action: 'get_term_image_url',
   term_id: $term_id,
       //security: security
     };
     jQuery.ajax({
       type: "POST",
       url: bb.adminurl,
       data: data,
       async: false,
       success: function(data) {
         image_url = data;
       },
       error: function() {
         console.log("error with selecting images");
       }
     });

     return image_url;
   }


/* Load More Items
----------------------*/
var itemLoads = 1;

function loadMoreItems($postType){
  $post = ($postType === "casestudy" ? 'casestudy' : "posts");
  itemLoads++;
  $url = '/wp-json/wp/v2/' + $post + '?per_page=4&page=' + itemLoads;
  $.ajax( {
    url:  $url,
    beforeSend: function(jqXHR, settings){
     $('.js-more-items').text('Loading');
    },
     complete: function(jqXHR, textStatus){
     $('.js-more-items').text('Show More');
    },
    success: function ( data,textStatus, request ) {
      $html ='';
      $loads = (itemLoads + 1);
      if($loads >= request.getResponseHeader('X-WP-TotalPages')){
        $('.js-more-items').fadeOut();
      }

      $b=0;
      $.each(data, function(index, value) {
        $link = value.slug;
        $post_title = value.title.rendered;
        $term_id = value.id;
        $date = $.format.date(value.date, "MMMM d yyyy");
        $intro_text = value.acf.intro_text;
        $image = (value.better_featured_image !== null? value.better_featured_image.media_details.sizes.journal_thumb.source_url : '');
        $alt = (value.better_featured_image!== null? value.better_featured_image.alt_text : '');

        if($postType ==='casestudy'){

            //case type
            $category = get_term_data(value.casetype[0],'casetype');
            if($category !== false){
              $meta = "<span class=\"meta-divider\">/</span></span><a href=\"" + $category.slug + "\" class=\"category-meta\">" + $category.name + "</a></p>";
            }else{
              $meta = "";
            }

              //case_product_type
              $cptHtml = '';
              $countTerms = value.case_product_type.length;
              $terms = '';
              $termsData = value.case_product_type;
              $.each($termsData,function(index, value){
                $case_product_type = get_term_data(value,'case_product_type');
                if($case_product_type !== false){
                  $div = ($countTerms > (index + 1)? "<span class=\"meta-divider hidden-xs\">/</span>" : "");
                  $terms += $case_product_type.name + $div;
                }
              });
              $termshtml = "<span class=\"blog-dates\"> " + $terms +  "</span>";

            }else{
              $category = getCategory(value.categories[0]);
              if($category !== false){
                $meta = "<span class=\"meta-divider\">/</span></span><a href=\"" + $category.slug + "\" class=\"category-meta\">" + $category.name + "</a></p>";
              }else{
                $meta = "";
              }
            }

            if($post === 'posts'){
              $template = $([
               "<article class=\"col-md-6\" data-mh=\"item-group\">",
               "  <div class=\"item-block journal-block\">",
               "     <div class=\"item-block__img-holder\">",
               "        <a href=\"" + $link + "\" title=\"\"> <img src=\"" + $image + "\" alt=\"" + $alt + "\"></a>",
               "     </div>",
               "     <p class=\"item-block__meta\"><span class=\"blog-dates\">" + $date + "</span>",
               "       " + $meta + "",
               "      <h2 class=\"item-block__post-title\">" + $post_title + "</h2>",
               "       <p>" + $intro_text + "</p>",
               "      <a href=\"" + $link + "\" class=\"more\">+ READ MORE</a>",
               "  </div>",
               "</article>"
               ].join("\n"));
            }else if($post === 'casestudy'){
              $template = $([
               "<article class=\"col-md-6\" data-mh=\"item-group\">",
               "  <div class=\"item-block journal-block\">",
               "     <div class=\"item-block__img-holder\">",
               "        <a href=\"" + $link + "\" title=\"\"> <img src=\"" + $image + "\" alt=\"" + $alt + "\"></a>",
               "     </div>",
               "     <p class=\"item-block__meta\"><span class=\"blog-dates\">" + $termshtml + "</span>",
               "       " + $meta + "",
               "      <h2 class=\"item-block__post-title\">" + $post_title + "</h2>",
               "       <p>" + $intro_text + "</p>",
               "      <a href=\"" + $link + "\" class=\"more\">+ READ MORE</a>",
               "  </div>",
               "</article>"
               ].join("\n"));
            }

            $html += $template[0].outerHTML;
            $b++;

          });
      $('.item-list-wrap').append("<div class='row'>" + $html + "</div>").fadeIn();
    },
    //cache: false
  });
}


/* Get Category
----------------------*/
function getCategory($cat_id){
  var category_data;
  var data = {
   action: 'get_category_id',
   cat_id: $cat_id,
       //security: security
     };
     jQuery.ajax({
       type: "POST",
       url: bb.adminurl,
       data: data,
       async: false,
       success: function(data) {
         category_data = data;
       },
       error: function() {
         console.log("error with terms");
       }
     });

     return category_data;
   }

   function get_term_data($term_id,$type){
    var term_data;
    var data = {
     action: 'get_term_data',
     term_id: $term_id,
     type: $type,
       //security: security
     };
     jQuery.ajax({
       type: "POST",
       url: bb.adminurl,
       data: data,
       async: false,
       success: function(data) {
         term_data = data;
       },
       error: function() {
         console.log("error with collecting data");
       }
     });

     return term_data;
   }


/*
 * jQuery SlideShow plugin
 */

 /* jshint ignore:start */
 ;(function($){
  function FadeGallery(options) {
    this.options = $.extend({
      slides: 'ul.slideset > li',
      activeClass:'active',
      disabledClass:'disabled',
      btnPrev: 'a.btn-prev',
      btnNext: 'a.btn-next',
      generatePagination: true,
      pagerList: '<ul>',
      pagerListItem: '<li><a href="#"></a></li>',
      pagerListItemText: 'a',
      pagerLinks: '.pagination li',
      currentNumber: 'span.current-num',
      totalNumber: 'span.total-num',
      btnPlay: '.btn-play',
      btnPause: '.btn-pause',
      btnPlayPause: '.btn-play-pause',
      galleryReadyClass: 'gallery-js-ready',
      autorotationActiveClass: 'autorotation-active',
      autorotationDisabledClass: 'autorotation-disabled',
      autorotationStopAfterClick: false,
      circularRotation: true,
      switchSimultaneously: true,
      disableWhileAnimating: false,
      disableFadeIE: false,
      autoRotation: false,
      pauseOnHover: true,
      autoHeight: false,
      useSwipe: false,
      swipeThreshold: 15,
      switchTime: 4000,
      animSpeed: 600,
      pagerHolder: '.pagination',
      event:'click'
    }, options);
    this.init();
  }
  FadeGallery.prototype = {
    init: function() {
      if(this.options.holder) {
        this.findElements();
        this.attachEvents();
        this.refreshState(true);
        this.autoRotate();
        this.makeCallback('onInit', this);
      }
    },
    findElements: function() {
      // control elements
      this.gallery = $(this.options.holder).addClass(this.options.galleryReadyClass);
      this.slides = this.gallery.find(this.options.slides);
      this.slidesHolder = this.slides.eq(0).parent();
      this.stepsCount = this.slides.length;
      this.btnPrev = this.gallery.find(this.options.btnPrev);
      this.btnNext = this.gallery.find(this.options.btnNext);
      this.currentIndex = 0;

      // disable fade effect in old IE
      if(this.options.disableFadeIE && !$.support.opacity) {
        this.options.animSpeed = 0;
      }

      // create gallery pagination
      if(typeof this.options.generatePagination === 'string') {
        this.pagerHolder = this.gallery.find(this.options.generatePagination).empty();
        this.pagerList = $(this.options.pagerList).appendTo(this.pagerHolder);
        for(var i = 0; i < this.stepsCount; i++) {
          $(this.options.pagerListItem).appendTo(this.pagerList).find(this.options.pagerListItemText).text(i+1);
        }
        this.pagerLinks = this.pagerList.children();
      } else {
        this.pagerLinks = this.gallery.find(this.options.pagerLinks);
      }

      // get start index
      var activeSlide = this.slides.filter('.'+this.options.activeClass);
      if(activeSlide.length) {
        this.currentIndex = this.slides.index(activeSlide);
      }
      this.prevIndex = this.currentIndex;

      // autorotation control buttons
      this.btnPlay = this.gallery.find(this.options.btnPlay);
      this.btnPause = this.gallery.find(this.options.btnPause);
      this.btnPlayPause = this.gallery.find(this.options.btnPlayPause);

      // misc elements
      this.curNum = this.gallery.find(this.options.currentNumber);
      this.allNum = this.gallery.find(this.options.totalNumber);

      // handle flexible layout
      this.slides.css({display:'block',opacity:0}).eq(this.currentIndex).css({
        opacity:''
      });
    },
    attachEvents: function() {
      var self = this;

      // flexible layout handler
      this.resizeHandler = function() {
        self.onWindowResize();
      };
      $(window).bind('load resize orientationchange', this.resizeHandler);

      if(this.btnPrev.length) {
        this.btnPrevHandler = function(e){
          e.preventDefault();
          self.prevSlide();
          if(self.options.autorotationStopAfterClick) {
            self.stopRotation();
          }
        };
        this.btnPrev.bind(this.options.event, this.btnPrevHandler);
      }
      if(this.btnNext.length) {
        this.btnNextHandler = function(e) {
          e.preventDefault();
          self.nextSlide();
          if(self.options.autorotationStopAfterClick) {
            self.stopRotation();
          }
        };
        this.btnNext.bind(this.options.event, this.btnNextHandler);
      }
      if(this.pagerLinks.length) {
        this.pagerLinksHandler = function(e) {
          e.preventDefault();
          self.numSlide(self.pagerLinks.index(e.currentTarget));
          if(self.options.autorotationStopAfterClick) {
            self.stopRotation();
          }
        };
        this.pagerLinks.bind(self.options.event, this.pagerLinksHandler);
      }

      // autorotation buttons handler
      if(this.btnPlay.length) {
        this.btnPlayHandler = function(e) {
          e.preventDefault();
          self.startRotation();
        };
        this.btnPlay.bind(this.options.event, this.btnPlayHandler);
      }
      if(this.btnPause.length) {
        this.btnPauseHandler = function(e) {
          e.preventDefault();
          self.stopRotation();
        };
        this.btnPause.bind(this.options.event, this.btnPauseHandler);
      }
      if(this.btnPlayPause.length) {
        this.btnPlayPauseHandler = function(e){
          e.preventDefault();
          if(!self.gallery.hasClass(self.options.autorotationActiveClass)) {
            self.startRotation();
          } else {
            self.stopRotation();
          }
        };
        this.btnPlayPause.bind(this.options.event, this.btnPlayPauseHandler);
      }

      // swipe gestures handler
      if(this.options.useSwipe && window.Hammer && isTouchDevice) {
        this.swipeHandler = new Hammer.Manager(this.gallery[0]);
        this.swipeHandler.add(new Hammer.Swipe({
          direction: Hammer.DIRECTION_HORIZONTAL,
          threshold: self.options.swipeThreshold
        }));
        this.swipeHandler.on('swipeleft', function() {
          self.nextSlide();
        }).on('swiperight', function() {
          self.prevSlide();
        });
      }

      // pause on hover handling
      if(this.options.pauseOnHover) {
        this.hoverHandler = function() {
          if(self.options.autoRotation) {
            self.galleryHover = true;
            self.pauseRotation();
          }
        };
        this.leaveHandler = function() {
          if(self.options.autoRotation) {
            self.galleryHover = false;
            self.resumeRotation();
          }
        };
        this.gallery.bind({mouseenter: this.hoverHandler, mouseleave: this.leaveHandler});
      }
    },
    onWindowResize: function(){
      if(this.options.autoHeight) {
        this.slidesHolder.css({height: this.slides.eq(this.currentIndex).outerHeight(true) });
      }
    },
    prevSlide: function() {
      if(!(this.options.disableWhileAnimating && this.galleryAnimating)) {
        this.prevIndex = this.currentIndex;
        if(this.currentIndex > 0) {
          this.currentIndex--;
          this.switchSlide();
        } else if(this.options.circularRotation) {
          this.currentIndex = this.stepsCount - 1;
          this.switchSlide();
        }
      }
    },
    nextSlide: function(fromAutoRotation) {
      if(!(this.options.disableWhileAnimating && this.galleryAnimating)) {
        this.prevIndex = this.currentIndex;
        if(this.currentIndex < this.stepsCount - 1) {
          this.currentIndex++;
          this.switchSlide();
        } else if(this.options.circularRotation || fromAutoRotation === true) {
          this.currentIndex = 0;
          this.switchSlide();
        }
      }
    },
    numSlide: function(c) {
      if(this.currentIndex != c) {
        this.prevIndex = this.currentIndex;
        this.currentIndex = c;
        this.switchSlide();
      }
    },
    switchSlide: function() {
      var self = this;
      if(this.slides.length > 1) {
        this.galleryAnimating = true;
        if(!this.options.animSpeed) {
          this.slides.eq(this.prevIndex).css({opacity:0});
        } else {
          this.slides.eq(this.prevIndex).stop().animate({opacity:0},{duration: this.options.animSpeed});
        }

        this.switchNext = function() {
          if(!self.options.animSpeed) {
            self.slides.eq(self.currentIndex).css({opacity:''});
          } else {
            self.slides.eq(self.currentIndex).stop().animate({opacity:1},{duration: self.options.animSpeed});
          }
          clearTimeout(this.nextTimer);
          this.nextTimer = setTimeout(function() {
            self.slides.eq(self.currentIndex).css({opacity:''});
            self.galleryAnimating = false;
            self.autoRotate();

            // onchange callback
            self.makeCallback('onChange', self);
          }, self.options.animSpeed);
        };

        if(this.options.switchSimultaneously) {
          self.switchNext();
        } else {
          clearTimeout(this.switchTimer);
          this.switchTimer = setTimeout(function(){
            self.switchNext();
          }, this.options.animSpeed);
        }
        this.refreshState();

        // onchange callback
        this.makeCallback('onBeforeChange', this);
      }
    },
    refreshState: function(initial) {
      this.slides.removeClass(this.options.activeClass).eq(this.currentIndex).addClass(this.options.activeClass);
      this.pagerLinks.removeClass(this.options.activeClass).eq(this.currentIndex).addClass(this.options.activeClass);
      this.curNum.html(this.currentIndex+1);
      this.allNum.html(this.stepsCount);

      // initial refresh
      if(this.options.autoHeight) {
        if(initial) {
          this.slidesHolder.css({height: this.slides.eq(this.currentIndex).outerHeight(true) });
        } else {
          this.slidesHolder.stop().animate({height: this.slides.eq(this.currentIndex).outerHeight(true)}, {duration: this.options.animSpeed});
        }
      }

      // disabled state
      if(!this.options.circularRotation) {
        this.btnPrev.add(this.btnNext).removeClass(this.options.disabledClass);
        if(this.currentIndex === 0) this.btnPrev.addClass(this.options.disabledClass);
        if(this.currentIndex === this.stepsCount - 1) this.btnNext.addClass(this.options.disabledClass);
      }

      // add class if not enough slides
      this.gallery.toggleClass('not-enough-slides', this.stepsCount === 1);
    },
    startRotation: function() {
      this.options.autoRotation = true;
      this.galleryHover = false;
      this.autoRotationStopped = false;
      this.resumeRotation();
    },
    stopRotation: function() {
      this.galleryHover = true;
      this.autoRotationStopped = true;
      this.pauseRotation();
    },
    pauseRotation: function() {
      this.gallery.addClass(this.options.autorotationDisabledClass);
      this.gallery.removeClass(this.options.autorotationActiveClass);
      clearTimeout(this.timer);
    },
    resumeRotation: function() {
      if(!this.autoRotationStopped) {
        this.gallery.addClass(this.options.autorotationActiveClass);
        this.gallery.removeClass(this.options.autorotationDisabledClass);
        this.autoRotate();
      }
    },
    autoRotate: function() {
      var self = this;
      clearTimeout(this.timer);
      if(this.options.autoRotation && !this.galleryHover && !this.autoRotationStopped) {
        this.gallery.addClass(this.options.autorotationActiveClass);
        this.timer = setTimeout(function(){
          self.nextSlide(true);
        }, this.options.switchTime);
      } else {
        this.pauseRotation();
      }
    },
    makeCallback: function(name) {
      if(typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
    destroy: function() {
      // navigation buttons handler
      this.btnPrev.unbind(this.options.event, this.btnPrevHandler);
      this.btnNext.unbind(this.options.event, this.btnNextHandler);
      this.pagerLinks.unbind(this.options.event, this.pagerLinksHandler);
      $(window).unbind('load resize orientationchange', this.resizeHandler);

      // remove autorotation handlers
      this.stopRotation();
      this.btnPlay.unbind(this.options.event, this.btnPlayHandler);
      this.btnPause.unbind(this.options.event, this.btnPauseHandler);
      this.btnPlayPause.unbind(this.options.event, this.btnPlayPauseHandler);
      this.gallery.unbind('mouseenter', this.hoverHandler);
      this.gallery.unbind('mouseleave', this.leaveHandler);

      // remove swipe handler if used
      if(this.swipeHandler) {
        this.swipeHandler.destroy();
      }
      if(typeof this.options.generatePagination === 'string') {
        this.pagerHolder.empty();
      }

      // remove unneeded classes and styles
      var unneededClasses = [this.options.galleryReadyClass, this.options.autorotationActiveClass, this.options.autorotationDisabledClass];
      this.gallery.removeClass(unneededClasses.join(' '));
      this.slidesHolder.add(this.slides).removeAttr('style');
    }
  };

  // detect device type
  var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

  // jquery plugin
  $.fn.fadeGallery = function(opt){
    return this.each(function(){
      $(this).data('FadeGallery', new FadeGallery($.extend(opt,{holder:this})));
    });
  };
}(jQuery));

/*
 * Simple Mobile Navigation
 */
(function($) {

  $.fn.jPushMenu = function(customOptions) {
    var backClick = function(e){
      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }

      var $parent = $(this).parents('ul');
      $parent.removeClass('side active');
    };

    var childClick = function(e){
      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }

      var $menu = $(this).next('.sub:first');
      $menu.addClass('active');
      $('.menu-top').addClass('side');

    };

    var o = $.extend({}, $.fn.jPushMenu.defaultOptions, customOptions),
        cm = $.fn.jPushMenu.currentMenu,
        $backLink = $('<a href="#!"><img src="/wp-content/themes/bluebell/dist/images/arrow_left.svg" />Back</a>').wrap($('<li />', { 'class': 'cbp-spmenu__back'})).parent();

    $backLink.on('click', backClick);

    $(this).addClass('jPushMenuBtn');

    this.each(function(){
      var menu = $(this).data('menu'),
          href = $(this).attr('href'),
          target = '.menu' + menu,
          $firstList = $(target).find('ul:first');

      $firstList.prepend('<li><a href="/">Home</a></li>');

      $list = $(target).find('li ul');

      if($list) {
        $list.each(function(){
          $parentLink = $(this).prev('a:first');
          parentHref = $parentLink.attr('href');

          $(this).prepend('<li class="cbp-spmenu__parent">' + $parentLink.text() + '</li>');
          $(this).prepend($backLink.clone(true));
          $parentLink.addClass('children').on('click touchend', childClick);
          $(this).addClass('sub');
        });
      }
    });

    $(this).click(function() {
      var menu = $(this).data('menu'),
          target = '.menu' + menu;

      if($(this).is('.disabled')) {
        return false;
      }

      if(cm == menu) {
        jPushMenu.close();
        return false;
      }

      if(cm != null) {
        jPushMenu.close();
      }

      cm = menu;

      $(target).addClass(o.menuOpenClass);

      if($(this).is('.'+o.pushBodyClass)) {
        $('body').addClass( 'cbp-spmenu-push-toleft' );
      }

      /* disable all other button*/
      $('.jPushMenuBtn').not($(this)).toggleClass('disabled');

      return false;
    });

    var jPushMenu = {
      close: function () {
        cm = null;
        $('.jPushMenuBtn,body,.cbp-spmenu').removeClass('disabled active cbp-spmenu-open cbp-spmenu-push-toleft');
      }
    }


    $(document).click(function() {
      jPushMenu.close();
    });

    $('.cbp-spmenu .close').click(function() {
      jPushMenu.close();
    });

    $('.cbp-spmenu,.toggle-menu').click(function(e){
      e.stopPropagation();
    });

  };

  $.fn.jPushMenu.defaultOptions = {
    menuOpenClass   : 'cbp-spmenu-open',
    pushBodyClass   : 'push-body',

  };

  $.fn.jPushMenu.currentMenu = null;
})(jQuery);


// navigation accesibility module
function TouchNav(opt) {
  this.options = {
    hoverClass: 'hover',
    menuItems: 'li',
    menuOpener: 'a',
    menuDrop: 'ul',
    navBlock: null
  };
  for(var p in opt) {
    if(opt.hasOwnProperty(p)) {
      this.options[p] = opt[p];
    }
  }
  this.init();
}
TouchNav.isActiveOn = function(elem) {
  return elem && elem.touchNavActive;
};
TouchNav.prototype = {
  init: function() {
    if(typeof this.options.navBlock === 'string') {
      this.menu = document.getElementById(this.options.navBlock);
    } else if(typeof this.options.navBlock === 'object') {
      this.menu = this.options.navBlock;
    }
    if(this.menu) {
      this.addEvents();
    }
  },
  addEvents: function() {
    // attach event handlers
    var self = this;
    var touchEvent = (navigator.pointerEnabled && 'pointerdown') || (navigator.msPointerEnabled && 'MSPointerDown') || (this.isTouchDevice && 'touchstart');
    this.menuItems = lib.queryElementsBySelector(this.options.menuItems, this.menu);

    var initMenuItem = function(item) {
      var currentDrop = lib.queryElementsBySelector(self.options.menuDrop, item)[0],
      currentOpener = lib.queryElementsBySelector(self.options.menuOpener, item)[0];

      // only for touch input devices
      if( currentDrop && currentOpener && (self.isTouchDevice || self.isPointerDevice) ) {
        lib.event.add(currentOpener, 'click', lib.bind(self.clickHandler, self));
        lib.event.add(currentOpener, 'mousedown', lib.bind(self.mousedownHandler, self));
        lib.event.add(currentOpener, touchEvent, function(e){
          if( !self.isTouchPointerEvent(e) ) {
            self.preventCurrentClick = false;
            return;
          }
          self.touchFlag = true;
          self.currentItem = item;
          self.currentLink = currentOpener;
          self.pressHandler.apply(self, arguments);
        });
      }
      // for desktop computers and touch devices
      jQuery(item).bind('mouseenter', function(){
        if(!self.touchFlag) {
          self.currentItem = item;
          self.mouseoverHandler();
        }
      });
      jQuery(item).bind('mouseleave', function(){
        if(!self.touchFlag) {
          self.currentItem = item;
          self.mouseoutHandler();
        }
      });
      item.touchNavActive = true;
    };

    // addd handlers for all menu items
    for(var i = 0; i < this.menuItems.length; i++) {
      initMenuItem(self.menuItems[i]);
    }

    // hide dropdowns when clicking outside navigation
    if(this.isTouchDevice || this.isPointerDevice) {
      lib.event.add(document.documentElement, 'mousedown', lib.bind(this.clickOutsideHandler, this));
      lib.event.add(document.documentElement, touchEvent, lib.bind(this.clickOutsideHandler, this));
    }
  },
  mousedownHandler: function(e) {
    if(this.touchFlag) {
      e.preventDefault();
      this.touchFlag = false;
      this.preventCurrentClick = false;
    }
  },
  mouseoverHandler: function() {
    lib.addClass(this.currentItem, this.options.hoverClass);
    jQuery(this.currentItem).trigger('itemhover');
  },
  mouseoutHandler: function() {
    lib.removeClass(this.currentItem, this.options.hoverClass);
    jQuery(this.currentItem).trigger('itemleave');
  },
  hideActiveDropdown: function() {
    for(var i = 0; i < this.menuItems.length; i++) {
      if(lib.hasClass(this.menuItems[i], this.options.hoverClass)) {
        lib.removeClass(this.menuItems[i], this.options.hoverClass);
        jQuery(this.menuItems[i]).trigger('itemleave');
      }
    }
    this.activeParent = null;
  },
  pressHandler: function(e) {
    // hide previous drop (if active)
    if(this.currentItem !== this.activeParent) {
      if(this.activeParent && this.currentItem.parentNode === this.activeParent.parentNode) {
        lib.removeClass(this.activeParent, this.options.hoverClass);
      } else if(!this.isParent(this.activeParent, this.currentLink)) {
        this.hideActiveDropdown();
      }
    }
    // handle current drop
    this.activeParent = this.currentItem;
    if(lib.hasClass(this.currentItem, this.options.hoverClass)) {
      this.preventCurrentClick = false;
    } else {
      e.preventDefault();
      this.preventCurrentClick = true;
      lib.addClass(this.currentItem, this.options.hoverClass);
      jQuery(this.currentItem).trigger('itemhover');
    }
  },
  clickHandler: function(e) {
    // prevent first click on link
    if(this.preventCurrentClick) {
      e.preventDefault();
    }
  },
  clickOutsideHandler: function(event) {
    var e = event.changedTouches ? event.changedTouches[0] : event;
    if(this.activeParent && !this.isParent(this.menu, e.target)) {
      this.hideActiveDropdown();
      this.touchFlag = false;
    }
  },
  isParent: function(parent, child) {
    while(child.parentNode) {
      if(child.parentNode == parent) {
        return true;
      }
      child = child.parentNode;
    }
    return false;
  },
  isTouchPointerEvent: function(e) {
    return (e.type.indexOf('touch') > -1) ||
    (navigator.pointerEnabled && e.pointerType === 'touch') ||
    (navigator.msPointerEnabled && e.pointerType == e.MSPOINTER_TYPE_TOUCH);
  },
  isPointerDevice: (function() {
    return !!(navigator.pointerEnabled || navigator.msPointerEnabled);
  }()),
  isTouchDevice: (function() {
    return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
  }())
};

/*
 * Utility module
 */
 lib = {
  hasClass: function(el,cls) {
    return el && el.className ? el.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)')) : false;
  },
  addClass: function(el,cls) {
    if (el && !this.hasClass(el,cls)) el.className += " "+cls;
  },
  removeClass: function(el,cls) {
    if (el && this.hasClass(el,cls)) {el.className=el.className.replace(new RegExp('(\\s|^)'+cls+'(\\s|$)'),' ');}
  },
  extend: function(obj) {
    for(var i = 1; i < arguments.length; i++) {
      for(var p in arguments[i]) {
        if(arguments[i].hasOwnProperty(p)) {
          obj[p] = arguments[i][p];
        }
      }
    }
    return obj;
  },
  each: function(obj, callback) {
    var property, len;
    if(typeof obj.length === 'number') {
      for(property = 0, len = obj.length; property < len; property++) {
        if(callback.call(obj[property], property, obj[property]) === false) {
          break;
        }
      }
    } else {
      for(property in obj) {
        if(obj.hasOwnProperty(property)) {
          if(callback.call(obj[property], property, obj[property]) === false) {
            break;
          }
        }
      }
    }
  },
  event: (function() {
    var fixEvent = function(e) {
      e = e || window.event;
      if(e.isFixed) return e; else e.isFixed = true;
      if(!e.target) e.target = e.srcElement;
      e.preventDefault = e.preventDefault || function() {this.returnValue = false;};
      e.stopPropagation = e.stopPropagation || function() {this.cancelBubble = true;};
      return e;
    };
    return {
      add: function(elem, event, handler) {
        if(!elem.events) {
          elem.events = {};
          elem.handle = function(e) {
            var ret, handlers = elem.events[e.type];
            e = fixEvent(e);
            for(var i = 0, len = handlers.length; i < len; i++) {
              if(handlers[i]) {
                ret = handlers[i].call(elem, e);
                if(ret === false) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }
            }
          };
        }
        if(!elem.events[event]) {
          elem.events[event] = [];
          if(elem.addEventListener) elem.addEventListener(event, elem.handle, false);
          else if(elem.attachEvent) elem.attachEvent('on'+event, elem.handle);
        }
        elem.events[event].push(handler);
      },
      remove: function(elem, event, handler) {
        var handlers = elem.events[event];
        for(var i = handlers.length - 1; i >= 0; i--) {
          if(handlers[i] === handler) {
            handlers.splice(i,1);
          }
        }
        if(!handlers.length) {
          delete elem.events[event];
          if(elem.removeEventListener) elem.removeEventListener(event, elem.handle, false);
          else if(elem.detachEvent) elem.detachEvent('on'+event, elem.handle);
        }
      }
    };
  }()),
  queryElementsBySelector: function(selector, scope) {
    scope = scope || document;
    if(!selector) return [];
    if(selector === '>*') return scope.children;
    if(typeof document.querySelectorAll === 'function') {
      return scope.querySelectorAll(selector);
    }
    var selectors = selector.split(',');
    var resultList = [];
    for(var s = 0; s < selectors.length; s++) {
      var currentContext = [scope || document];
      var tokens = selectors[s].replace(/^\s+/,'').replace(/\s+$/,'').split(' ');
      for (var i = 0; i < tokens.length; i++) {
        token = tokens[i].replace(/^\s+/,'').replace(/\s+$/,'');
        if (token.indexOf('#') > -1) {
          var bits = token.split('#'), tagName = bits[0], id = bits[1];
          var element = document.getElementById(id);
          if (element && tagName && element.nodeName.toLowerCase() != tagName) {
            return [];
          }
          currentContext = element ? [element] : [];
          continue;
        }
        if (token.indexOf('.') > -1) {
          var bits = token.split('.'), tagName = bits[0] || '*', className = bits[1], found = [], foundCount = 0;
          for (var h = 0; h < currentContext.length; h++) {
            var elements;
            if (tagName == '*') {
              elements = currentContext[h].getElementsByTagName('*');
            } else {
              elements = currentContext[h].getElementsByTagName(tagName);
            }
            for (var j = 0; j < elements.length; j++) {
              found[foundCount++] = elements[j];
            }
          }
          currentContext = [];
          var currentContextIndex = 0;
          for (var k = 0; k < found.length; k++) {
            if (found[k].className && found[k].className.match(new RegExp('(\\s|^)'+className+'(\\s|$)'))) {
              currentContext[currentContextIndex++] = found[k];
            }
          }
          continue;
        }
        if (token.match(/^(\w*)\[(\w+)([=~\|\^\$\*]?)=?"?([^\]"]*)"?\]$/)) {
          var tagName = RegExp.$1 || '*', attrName = RegExp.$2, attrOperator = RegExp.$3, attrValue = RegExp.$4;
          if(attrName.toLowerCase() == 'for' && this.browser.msie && this.browser.version < 8) {
            attrName = 'htmlFor';
          }
          var found = [], foundCount = 0;
          for (var h = 0; h < currentContext.length; h++) {
            var elements;
            if (tagName == '*') {
              elements = currentContext[h].getElementsByTagName('*');
            } else {
              elements = currentContext[h].getElementsByTagName(tagName);
            }
            for (var j = 0; elements[j]; j++) {
              found[foundCount++] = elements[j];
            }
          }
          currentContext = [];
          var currentContextIndex = 0, checkFunction;
          switch (attrOperator) {
            case '=': checkFunction = function(e) { return (e.getAttribute(attrName) == attrValue) }; break;
            case '~': checkFunction = function(e) { return (e.getAttribute(attrName).match(new RegExp('(\\s|^)'+attrValue+'(\\s|$)'))) }; break;
            case '|': checkFunction = function(e) { return (e.getAttribute(attrName).match(new RegExp('^'+attrValue+'-?'))) }; break;
            case '^': checkFunction = function(e) { return (e.getAttribute(attrName).indexOf(attrValue) == 0) }; break;
            case '$': checkFunction = function(e) { return (e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length) }; break;
            case '*': checkFunction = function(e) { return (e.getAttribute(attrName).indexOf(attrValue) > -1) }; break;
            default : checkFunction = function(e) { return e.getAttribute(attrName) };
          }
          currentContext = [];
          var currentContextIndex = 0;
          for (var k = 0; k < found.length; k++) {
            if (checkFunction(found[k])) {
              currentContext[currentContextIndex++] = found[k];
            }
          }
          continue;
        }
        tagName = token;
        var found = [], foundCount = 0;
        for (var h = 0; h < currentContext.length; h++) {
          var elements = currentContext[h].getElementsByTagName(tagName);
          for (var j = 0; j < elements.length; j++) {
            found[foundCount++] = elements[j];
          }
        }
        currentContext = found;
      }
      resultList = [].concat(resultList,currentContext);
    }
    return resultList;
  },
  trim: function (str) {
    return str.replace(/^\s+/, '').replace(/\s+$/, '');
  },
  bind: function(f, scope, forceArgs){
    return function() {return f.apply(scope, typeof forceArgs !== 'undefined' ? [forceArgs] : arguments);};
  }
};

/*! Hammer.JS - v2.0.4 - 2014-09-28
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2014 Jorik Tangelder;
 * Licensed under the MIT license */
 if(Object.create){!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(k(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a}function i(a,b){return h(a,b,!0)}function j(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&h(d,c)}function k(a,b){return function(){return a.apply(b,arguments)}}function l(a,b){return typeof a==kb?a.apply(b?b[0]||d:d,b):a}function m(a,b){return a===d?b:a}function n(a,b,c){g(r(b),function(b){a.addEventListener(b,c,!1)})}function o(a,b,c){g(r(b),function(b){a.removeEventListener(b,c,!1)})}function p(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function q(a,b){return a.indexOf(b)>-1}function r(a){return a.trim().split(/\s+/g)}function s(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function t(a){return Array.prototype.slice.call(a,0)}function u(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];s(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function v(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ib.length;){if(c=ib[g],e=c?c+f:b,e in a)return e;g++}return d}function w(){return ob++}function x(a){var b=a.ownerDocument;return b.defaultView||b.parentWindow}function y(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){l(a.options.enable,[a])&&c.handler(b)},this.init()}function z(a){var b,c=a.options.inputClass;return new(b=c?c:rb?N:sb?Q:qb?S:M)(a,A)}function A(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&yb&&d-e===0,g=b&(Ab|Bb)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,B(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function B(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=E(b)),e>1&&!c.firstMultiple?c.firstMultiple=E(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=F(d);b.timeStamp=nb(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=J(h,i),b.distance=I(h,i),C(c,b),b.offsetDirection=H(b.deltaX,b.deltaY),b.scale=g?L(g.pointers,d):1,b.rotation=g?K(g.pointers,d):0,D(c,b);var j=a.element;p(b.srcEvent.target,j)&&(j=b.srcEvent.target),b.target=j}function C(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};(b.eventType===yb||f.eventType===Ab)&&(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function D(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Bb&&(i>xb||h.velocity===d)){var j=h.deltaX-b.deltaX,k=h.deltaY-b.deltaY,l=G(i,j,k);e=l.x,f=l.y,c=mb(l.x)>mb(l.y)?l.x:l.y,g=H(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function E(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:lb(a.pointers[c].clientX),clientY:lb(a.pointers[c].clientY)},c++;return{timeStamp:nb(),pointers:b,center:F(b),deltaX:a.deltaX,deltaY:a.deltaY}}function F(a){var b=a.length;if(1===b)return{x:lb(a[0].clientX),y:lb(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:lb(c/b),y:lb(d/b)}}function G(a,b,c){return{x:b/a||0,y:c/a||0}}function H(a,b){return a===b?Cb:mb(a)>=mb(b)?a>0?Db:Eb:b>0?Fb:Gb}function I(a,b,c){c||(c=Kb);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function J(a,b,c){c||(c=Kb);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function K(a,b){return J(b[1],b[0],Lb)-J(a[1],a[0],Lb)}function L(a,b){return I(b[0],b[1],Lb)/I(a[0],a[1],Lb)}function M(){this.evEl=Nb,this.evWin=Ob,this.allow=!0,this.pressed=!1,y.apply(this,arguments)}function N(){this.evEl=Rb,this.evWin=Sb,y.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function O(){this.evTarget=Ub,this.evWin=Vb,this.started=!1,y.apply(this,arguments)}function P(a,b){var c=t(a.touches),d=t(a.changedTouches);return b&(Ab|Bb)&&(c=u(c.concat(d),"identifier",!0)),[c,d]}function Q(){this.evTarget=Xb,this.targetIds={},y.apply(this,arguments)}function R(a,b){var c=t(a.touches),d=this.targetIds;if(b&(yb|zb)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=t(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return p(a.target,i)}),b===yb)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ab|Bb)&&delete d[g[e].identifier],e++;return h.length?[u(f.concat(h),"identifier",!0),h]:void 0}function S(){y.apply(this,arguments);var a=k(this.handler,this);this.touch=new Q(this.manager,a),this.mouse=new M(this.manager,a)}function T(a,b){this.manager=a,this.set(b)}function U(a){if(q(a,bc))return bc;var b=q(a,cc),c=q(a,dc);return b&&c?cc+" "+dc:b||c?b?cc:dc:q(a,ac)?ac:_b}function V(a){this.id=w(),this.manager=null,this.options=i(a||{},this.defaults),this.options.enable=m(this.options.enable,!0),this.state=ec,this.simultaneous={},this.requireFail=[]}function W(a){return a&jc?"cancel":a&hc?"end":a&gc?"move":a&fc?"start":""}function X(a){return a==Gb?"down":a==Fb?"up":a==Db?"left":a==Eb?"right":""}function Y(a,b){var c=b.manager;return c?c.get(a):a}function Z(){V.apply(this,arguments)}function $(){Z.apply(this,arguments),this.pX=null,this.pY=null}function _(){Z.apply(this,arguments)}function ab(){V.apply(this,arguments),this._timer=null,this._input=null}function bb(){Z.apply(this,arguments)}function cb(){Z.apply(this,arguments)}function db(){V.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function eb(a,b){return b=b||{},b.recognizers=m(b.recognizers,eb.defaults.preset),new fb(a,b)}function fb(a,b){b=b||{},this.options=i(b,eb.defaults),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.element=a,this.input=z(this),this.touchAction=new T(this,this.options.touchAction),gb(this,!0),g(b.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function gb(a,b){var c=a.element;g(a.options.cssProps,function(a,d){c.style[v(c.style,d)]=b?a:""})}function hb(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var ib=["","webkit","moz","MS","ms","o"],jb=b.createElement("div"),kb="function",lb=Math.round,mb=Math.abs,nb=Date.now,ob=1,pb=/mobile|tablet|ip(ad|hone|od)|android/i,qb="ontouchstart"in a,rb=v(a,"PointerEvent")!==d,sb=qb&&pb.test(navigator.userAgent),tb="touch",ub="pen",vb="mouse",wb="kinect",xb=25,yb=1,zb=2,Ab=4,Bb=8,Cb=1,Db=2,Eb=4,Fb=8,Gb=16,Hb=Db|Eb,Ib=Fb|Gb,Jb=Hb|Ib,Kb=["x","y"],Lb=["clientX","clientY"];y.prototype={handler:function(){},init:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(x(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&o(this.element,this.evEl,this.domHandler),this.evTarget&&o(this.target,this.evTarget,this.domHandler),this.evWin&&o(x(this.element),this.evWin,this.domHandler)}};var Mb={mousedown:yb,mousemove:zb,mouseup:Ab},Nb="mousedown",Ob="mousemove mouseup";j(M,y,{handler:function(a){var b=Mb[a.type];b&yb&&0===a.button&&(this.pressed=!0),b&zb&&1!==a.which&&(b=Ab),this.pressed&&this.allow&&(b&Ab&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:vb,srcEvent:a}))}});var Pb={pointerdown:yb,pointermove:zb,pointerup:Ab,pointercancel:Bb,pointerout:Bb},Qb={2:tb,3:ub,4:vb,5:wb},Rb="pointerdown",Sb="pointermove pointerup pointercancel";a.MSPointerEvent&&(Rb="MSPointerDown",Sb="MSPointerMove MSPointerUp MSPointerCancel"),j(N,y,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Pb[d],f=Qb[a.pointerType]||a.pointerType,g=f==tb,h=s(b,a.pointerId,"pointerId");e&yb&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ab|Bb)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Tb={touchstart:yb,touchmove:zb,touchend:Ab,touchcancel:Bb},Ub="touchstart",Vb="touchstart touchmove touchend touchcancel";j(O,y,{handler:function(a){var b=Tb[a.type];if(b===yb&&(this.started=!0),this.started){var c=P.call(this,a,b);b&(Ab|Bb)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:tb,srcEvent:a})}}});var Wb={touchstart:yb,touchmove:zb,touchend:Ab,touchcancel:Bb},Xb="touchstart touchmove touchend touchcancel";j(Q,y,{handler:function(a){var b=Wb[a.type],c=R.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:tb,srcEvent:a})}}),j(S,y,{handler:function(a,b,c){var d=c.pointerType==tb,e=c.pointerType==vb;if(d)this.mouse.allow=!1;else if(e&&!this.mouse.allow)return;b&(Ab|Bb)&&(this.mouse.allow=!0),this.callback(a,b,c)},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var Yb=v(jb.style,"touchAction"),Zb=Yb!==d,$b="compute",_b="auto",ac="manipulation",bc="none",cc="pan-x",dc="pan-y";T.prototype={set:function(a){a==$b&&(a=this.compute()),Zb&&(this.manager.element.style[Yb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){l(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),U(a.join(" "))},preventDefaults:function(a){if(!Zb){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=q(d,bc),f=q(d,dc),g=q(d,cc);return e||f&&c&Hb||g&&c&Ib?this.preventSrc(b):void 0}},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var ec=1,fc=2,gc=4,hc=8,ic=hc,jc=16,kc=32;V.prototype={defaults:{},set:function(a){return h(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=Y(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=Y(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=Y(a,this),-1===s(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=Y(a,this);var b=s(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(c.options.event+(b?W(d):""),a)}var c=this,d=this.state;hc>d&&b(!0),b(),d>=hc&&b(!0)},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=kc)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(kc|ec)))return!1;a++}return!0},recognize:function(a){var b=h({},a);return l(this.options.enable,[this,b])?(this.state&(ic|jc|kc)&&(this.state=ec),this.state=this.process(b),void(this.state&(fc|gc|hc|jc)&&this.tryEmit(b))):(this.reset(),void(this.state=kc))},process:function(){},getTouchAction:function(){},reset:function(){}},j(Z,V,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(fc|gc),e=this.attrTest(a);return d&&(c&Bb||!e)?b|jc:d||e?c&Ab?b|hc:b&fc?b|gc:fc:kc}}),j($,Z,{defaults:{event:"pan",threshold:10,pointers:1,direction:Jb},getTouchAction:function(){var a=this.options.direction,b=[];return a&Hb&&b.push(dc),a&Ib&&b.push(cc),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Hb?(e=0===f?Cb:0>f?Db:Eb,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Cb:0>g?Fb:Gb,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return Z.prototype.attrTest.call(this,a)&&(this.state&fc||!(this.state&fc)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=X(a.direction);b&&this.manager.emit(this.options.event+b,a),this._super.emit.call(this,a)}}),j(_,Z,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[bc]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&fc)},emit:function(a){if(this._super.emit.call(this,a),1!==a.scale){var b=a.scale<1?"in":"out";this.manager.emit(this.options.event+b,a)}}}),j(ab,V,{defaults:{event:"press",pointers:1,time:500,threshold:5},getTouchAction:function(){return[_b]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ab|Bb)&&!f)this.reset();else if(a.eventType&yb)this.reset(),this._timer=e(function(){this.state=ic,this.tryEmit()},b.time,this);else if(a.eventType&Ab)return ic;return kc},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===ic&&(a&&a.eventType&Ab?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=nb(),this.manager.emit(this.options.event,this._input)))}}),j(bb,Z,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[bc]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&fc)}}),j(cb,Z,{defaults:{event:"swipe",threshold:10,velocity:.65,direction:Hb|Ib,pointers:1},getTouchAction:function(){return $.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Hb|Ib)?b=a.velocity:c&Hb?b=a.velocityX:c&Ib&&(b=a.velocityY),this._super.attrTest.call(this,a)&&c&a.direction&&a.distance>this.options.threshold&&mb(b)>this.options.velocity&&a.eventType&Ab},emit:function(a){var b=X(a.direction);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),j(db,V,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:2,posThreshold:10},getTouchAction:function(){return[ac]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&yb&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ab)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||I(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=ic,this.tryEmit()},b.interval,this),fc):ic}return kc},failTimeout:function(){return this._timer=e(function(){this.state=kc},this.options.interval,this),kc},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==ic&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),eb.VERSION="2.0.4",eb.defaults={domEvents:!1,touchAction:$b,enable:!0,inputTarget:null,inputClass:null,preset:[[bb,{enable:!1}],[_,{enable:!1},["rotate"]],[cb,{direction:Hb}],[$,{direction:Hb},["swipe"]],[db],[db,{event:"doubletap",taps:2},["tap"]],[ab]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var lc=1,mc=2;fb.prototype={set:function(a){return h(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?mc:lc},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&ic)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===mc||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(fc|gc|hc)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof V)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;var b=this.recognizers;return a=this.get(a),b.splice(s(b,a),1),this.touchAction.update(),this},on:function(a,b){var c=this.handlers;return g(r(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this},off:function(a,b){var c=this.handlers;return g(r(a),function(a){b?c[a].splice(s(c[a],b),1):delete c[a]}),this},emit:function(a,b){this.options.domEvents&&hb(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&gb(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},h(eb,{INPUT_START:yb,INPUT_MOVE:zb,INPUT_END:Ab,INPUT_CANCEL:Bb,STATE_POSSIBLE:ec,STATE_BEGAN:fc,STATE_CHANGED:gc,STATE_ENDED:hc,STATE_RECOGNIZED:ic,STATE_CANCELLED:jc,STATE_FAILED:kc,DIRECTION_NONE:Cb,DIRECTION_LEFT:Db,DIRECTION_RIGHT:Eb,DIRECTION_UP:Fb,DIRECTION_DOWN:Gb,DIRECTION_HORIZONTAL:Hb,DIRECTION_VERTICAL:Ib,DIRECTION_ALL:Jb,Manager:fb,Input:y,TouchAction:T,TouchInput:Q,MouseInput:M,PointerEventInput:N,TouchMouseInput:S,SingleTouchInput:O,Recognizer:V,AttrRecognizer:Z,Tap:db,Pan:$,Swipe:cb,Pinch:_,Rotate:bb,Press:ab,on:n,off:o,each:g,merge:i,extend:h,inherit:j,bindFn:k,prefixed:v}),typeof define==kb&&define.amd?define(function(){return eb}):"undefined"!=typeof module&&module.exports?module.exports=eb:a[c]=eb}(window,document,"Hammer");}
